type Comparable = {
  [key: string]: unknown;
};

export default function hasChanged<T extends Comparable>(
  data1: T,
  data2: T,
): boolean {
  return JSON.stringify(data1) !== JSON.stringify(data2);
}
